import { Button, CircularProgress } from "@mui/material";
import React from "react";

const CustomSubmitButton = (props) => {
    const { type, onSubmit, btnTitle, loading, sx = {} , disabled} = props
    return (
        <>
            <Button
                sx={{
                    width: "100%",
                    borderRadius: "8px",
                    background: "rgba(107, 207, 207, 1)",
                    padding: "12px 12px",
                    fontWeight: "600",
                    fontSize: "13px",
                    color: "rgba(0, 0, 0, 1)",
                    textTransform: "capitalize",
                    textWrap: "nowrap",
                    "&:hover": {
                        background: "rgba(107, 207, 207, 1)",
                        color: "rgba(0, 0, 0, 1)",
                    },
                    "&:disabled":{
                        background: "#ddd",
                        color: "white",
                    },
                    ...sx,
                    fontFamily: "Poppins",
                }}
                type={type}
                onClick={onSubmit}
                disabled={disabled}
            >
                {loading ? (
                    <CircularProgress
                        size={32}
                        sx={{
                            color: "#fff",
                        }}
                    />
                ) : (
                    btnTitle
                )}
            </Button>
        </>
    );
};

export default CustomSubmitButton;
